import React from 'react'
import { StarFilled } from '@ant-design/icons'
import { Rate } from 'antd'
import { useTranslation } from 'lib/i18n'

import Link from 'components/Link/Link'
import useRouter from 'hooks/useRouter'

import styles from './ReviewRating.module.css'

type RateProps = {
  rating: number
  reviewCount?: number
  showReviewText?: boolean
  renderModalLink?: boolean
}

const MAX_REVIEW_COUNT = 99

const ReviewRating: React.FC<RateProps> = ({
  rating,
  reviewCount,
  showReviewText = true,
  renderModalLink = true,
}) => {
  const { query } = useRouter()
  const { t } = useTranslation()

  if (!rating && !reviewCount) return null

  const RateComponent = () => (
    <>
      <Rate
        className={styles.reviewRatingRate}
        character={<StarFilled className={styles.reviewRatingStar} />}
        value={Math.round(rating * 2) / 2}
        allowHalf
        disabled
      />

      {showReviewText && (
        <span className={styles.reviewRatingText}>
          {reviewCount >= MAX_REVIEW_COUNT
            ? t('ProfilePage.ReviewRating.headingMaxRating2', {
                defaultValue: '{{maxCount}}+ reviews',
                maxCount: MAX_REVIEW_COUNT,
              })
            : t('ProfilePage.ReviewRating.heading', {
                defaultValue: '{{count}} review',
                defaultValue_plural: '{{count}} reviews',
                count:
                  reviewCount > MAX_REVIEW_COUNT
                    ? MAX_REVIEW_COUNT
                    : reviewCount,
              })}
        </span>
      )}
    </>
  )

  if (renderModalLink) {
    return (
      <Link
        href={{
          pathname: '/profile/[slug]/',
          query: { ...query, reviews: '1' },
        }}
        as={`/profile/${query.slug}/reviews`}
        prefetch={false}
        passHref
      >
        <a tabIndex={-1} role="link" className={styles.reviewRating}>
          <RateComponent />
        </a>
      </Link>
    )
  }

  return <RateComponent />
}

export default ReviewRating
